import { Component, Injector, Input } from '@angular/core';

@Component({
    selector: 'app-image-with-dialog',
    templateUrl: './image-with-dialog.component.html',
    styleUrls: ['./image-with-dialog.component.css'],
    standalone: false
})
export class ImageWithDialogComponent{

  @Input() src: string;
  @Input() maxX = 64;
  @Input() maxY = 64;

  public isOpened = false;

  public now = (new Date()).getTime();

  public onImageClick()
  {
    this.isOpened = true;
  }
  public onDivClick()
  {
    this.isOpened = false;
  }
}
